import { Button, Modal, ModalContent, ModalFooter } from 'components/lib';
import { isIpad } from 'constants/browserDetection';
import { drawingSelectionNoticeModal } from 'copy/copy';
import React from 'react';
import appStoreIcon from '../../images/icon-download.png';

type Props = {
  closeButtonText: string;
  title: string;
  onModalClose: () => void;
};

const DrawingSelectionNoticeModal: React.FC<Props> = ({
  closeButtonText,
  title,
  onModalClose,
}) => {
  return (
    <Modal
      size={isIpad ? 'small' : 'medium'}
      onDismiss={onModalClose}
      title={title}
    >
      <div id="drawing-selection-notice-modal">
        <ModalContent>
          <div className="light font-size-5">
            <p className="mt0">
              {drawingSelectionNoticeModal.drawingViewNotSupported}
            </p>
            {isIpad ? (
              <>
                <p>{drawingSelectionNoticeModal.ipad.downloadAppHeader}</p>
                <div className="mt5 column items-center">
                  <a href="https://apps.apple.com/us/app/id1479484276">
                    <img
                      src={appStoreIcon}
                      alt="Open in App Store"
                      width="147px"
                    />
                  </a>
                </div>
                <p className="mb0">
                  {drawingSelectionNoticeModal.ipad.downloadAppFooter}
                </p>
              </>
            ) : (
              <>
                <p>{drawingSelectionNoticeModal.tablets.header}</p>
                <p className="mb0">
                  {drawingSelectionNoticeModal.tablets.footer}
                </p>
              </>
            )}
          </div>
        </ModalContent>
        <ModalFooter>
          <Button
            size="large"
            variant="tertiary"
            onClick={onModalClose}
            id="drawing-selection-notice-cancel-btn"
          >
            {closeButtonText}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default DrawingSelectionNoticeModal;
